import React from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { useTranslation } from "react-i18next";

export default function Support() {
  const { t } = useTranslation();
  const supportReasons = [
    { icon: '📚', title: "donate-supportReasons-print-title", desc: "donate-supportReasons-print-desc" },
    { icon: '🌐', title: 'donate-supportReasons-ship-title', desc: 'donate-supportReasons-ship-desc' },
    { icon: '⛓️', title: 'donate-supportReasons-out-title', desc: 'donate-supportReasons-out-desc' },
    { icon: '💻', title: 'donate-supportReasons-dig-title', desc: 'donate-supportReasons-dig-desc' }
  ];

  const commitments = [
    'donate-commitments1',
    'donate-commitments2',
    'donate-commitments3',
    'donate-commitments4',
    'donate-commitments5'
  ];

  const accountabilitySteps = [
    'donate-accountability1',
    'donate-accountability2',
    'donate-accountability3',
    'donate-accountability4'
  ];

  return (
    <Container className="py-5" style={{ color: '#2d3748', fontSize: '16px' }}>
      
      {/* Intro Section */}
      <Row className="justify-content-center text-center mb-5">
        <Col md={10} lg={9}>
          <h2 className="display-6 font-weight-bold mb-3 text-dark">{t("donate-more-heading")}</h2>
          <p className="text-secondary" style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
            {t("donate-more-description")}
          </p>
          <img
        className="img-thumbnail shadow-sm w-100"
        src={"https://www.chapellibrary.org/images/annual-highlight.png"}
        alt="International Orders"
        style={{ borderRadius: '8px', objectFit: 'cover' }}
      />
        </Col>
      </Row>

      {/* 1. Quote Card: The Faith Principle */}
      <Row className="justify-content-center mb-5">
        <Col lg={11}>
          <div className="p-4 bg-light rounded shadow-sm" style={{ borderLeft: '5px solid #007bff' }}>
            <h2 className="h3 font-weight-bold text-dark mb-3">{t("donate-faith-heading")}</h2>
            <p className="text-dark mb-4" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
              {t("donate-faith-description")}
            </p>
            <blockquote className="blockquote bg-white px-4 py-3 rounded border-top text-muted font-weight-bold" style={{ fontSize: '13px', letterSpacing: '0.5px', lineHeight: '1.5' }}>
              {t("donate-faith-solicit")}
              <span className="blockquote-footer d-block mt-2" dangerouslySetInnerHTML={{__html:t("donate-faith-inspired")}} style={{ fontSize: '11px' }}></span>
            </blockquote>
          </div>
        </Col>
      </Row>

      {/* Split Blocks: Financial Commitments, Gift Pathing, & Visual Data Maps */}
<Row className="align-items-stretch mb-5">
  {/* Left Column: Trust Assurances */}
  <Col lg={4} md={6} className="mb-4 mb-lg-0">
    <div className="h-100 p-4 rounded shadow-sm" style={{ background: 'linear-gradient(135deg, #f0f7f4 0%, #e2eff1 100%)', borderRadius: '12px' }}>
      <h2 className="h3 font-weight-bold text-dark mb-4">🛡️ {t("donate-commitment-heading")}</h2>
      <ul className="list-unstyled mb-0" style={{ lineHeight: '2' }}>
        {commitments.map((commitment, index) => (
          <li key={index} className="text-dark font-weight-bold mb-2" style={{ fontSize: '1rem' }}>
            <span className="text-sucess mr-2" style={{ fontSize: '1.1rem' }}>✓</span> {t(commitment)}
          </li>
        ))}
      </ul>
    </div>
  </Col>
  
  {/* Middle Column: Gift Pathing Text */}
  <Col lg={4} md={6} className="mb-4 mb-lg-0">
    <Card className="h-100 border-0 shadow-sm p-4 bg-white" style={{ borderRadius: '12px' }}>
      <h2 className="h3 font-weight-bold text-dark mb-3">{t("donate-separate-heading")}</h2>
      <CardText className="text-secondary" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
        {t("donate-separate-description1")}
      </CardText>
      <CardText className="text-secondary" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
        {t("donate-separate-description2")}
      </CardText>
    </Card>
  </Col>

  {/* Right Column: New Visual Image Showcase */}
  <Col lg={4} md={12} className="d-flex flex-column justify-content-between">
    <div className="d-flex flex-column h-100 justify-content-between" style={{ gap: '15px' }}>
      <img
        className="img-thumbnail shadow-sm w-100"
        src={"https://www.chapellibrary.org/images/intnl-orders.png"}
        alt="International Orders"
        style={{ "--aspect-ratio": "630/452", borderRadius: '8px', objectFit: 'cover' }}
      />
      <img
        className="img-thumbnail shadow-sm w-100"
        src={"https://www.chapellibrary.org/images/intnl-orders-map.jpg"}
        alt="Chapel Library Orders Map"
        style={{ "--aspect-ratio": "991/595", borderRadius: '8px', objectFit: 'cover' }}
      />
    </div>
  </Col>
</Row>

      {/* Core Grid Items */}
      <div className="mb-5 text-center">
        <div className="d-flex flex-wrap justify-content-center" style={{ gap: '20px' }}>
          {supportReasons.map((item, index) => (
            <Card 
              key={index} 
              className="border shadow-sm flex-grow-1" 
              style={{ 
                minWidth: '220px', 
                maxWidth: '260px', 
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <CardBody className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <span className="d-block mb-3" style={{ fontSize: '2.5rem' }}>{item.icon}</span>
                  <CardTitle tag="h4" className="text-primary font-weight-bold mb-3" style={{ fontSize: '1rem', letterSpacing: '0.3px' }}>
                    {t(item.title)}
                  </CardTitle>
                  <CardText className="text-secondary" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                    {t(item.desc)}
                  </CardText>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      </div>

      {/* Accountability Footer Block */}
      <Row className="justify-content-center text-center mt-5">
        <Col lg={10}>
          <h2 className="h2 font-weight-bold text-dark mb-3">{t("donate-501c3-heading")}</h2>
          <p className="text-secondary mb-4" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
            {t("donate-501c3-desc")}
          </p>
          
          {/* Enhanced Document Access Component Area */}
          <div className="d-flex flex-wrap justify-content-center align-items-center mb-4" style={{ gap: '15px' }}>
            <a
              href={`${process.env.REACT_APP_API_URL}/pdf/financial/financial-statement.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-lg d-inline-flex align-items-center shadow-sm px-4 py-2 font-weight-bold"
              style={{ borderRadius: '8px', fontSize: '15px', transition: 'all 0.2s ease' }}
            >
              <span className="mr-2" style={{ fontSize: '1.25rem' }}>📄</span>
              {t("support-p3a")}
            </a>

            <a
              href={`${process.env.REACT_APP_API_URL}/pdf/financial/financial-statement-notes.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-lg d-inline-flex align-items-center shadow-sm px-4 py-2 font-weight-bold"
              style={{ borderRadius: '8px', fontSize: '15px', transition: 'all 0.2s ease' }}
            >
              <span className="mr-2" style={{ fontSize: '1.25rem' }}>📝</span>
              {t("support-p3b")}
            </a>
          </div>
          
          <hr className="my-5" style={{ borderStyle: 'dashed' }} />
          <h3 className="text-uppercase text-muted font-weight-bold tracking-wider mb-4" style={{ fontSize: '13px', letterSpacing: '2px' }}>
            {t("donate-accountability-heading")}
          </h3>
          
          {/* Timeline Node Flow */}
          <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ gap: '15px' }}>
            {accountabilitySteps.map((step, index) => (
              <React.Fragment key={index}>
                <div className="badge badge-light border text-dark px-4 py-2.5 shadow-sm font-weight-bold" style={{ fontSize: '14px', borderRadius: '50px' }}>
                  {index + 1}. {t(step)}
                </div>
                {index < accountabilitySteps.length - 1 && (
                  <span className="d-none d-sm-inline text-muted font-weight-bold" style={{ fontSize: '16px' }}>➔</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </Col>
      </Row>

    </Container>
  );
}